<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/Report/AverageBarcode'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label-required">รอบข้อมูล:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAprDateCycle'"
                    :name="'reAprDateCycle'"
                    :select2-options="reAprDateCycleOptions"
                    v-model="reAprDateCycle"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รายการ:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAprJobTypeCode'"
                    :name="'reAprJobTypeCode'"
                    :select2-options="reAprJobTypeCodeOptions"
                    multiple
                    v-model="reAprJobTypeCode"
                  ></select2> -->
                  <treeselect
                    v-model="reAprJobTypeCode"
                    :multiple="true"
                    :options="reAprJobTypeCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div
                v-show="this.$root.canShow([''])"
                class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3"
              >
                <div class="form-group">
                  <label>โรงงาน / คลังสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAprPlantCode'"
                    :name="'reAprPlantCode'"
                    :select2-options="reAprPlantCodeOptions"
                    multiple
                    v-model="reAprPlantCode"
                  ></select2> -->
                  <treeselect
                    v-model="reAprPlantCode"
                    :multiple="true"
                    :options="reAprPlantCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>หมวดหมู่สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAprProductGroupId'"
                    :name="'reAprProductGroupId'"
                    :select2-options="reAprProductGroupIdOptions"
                    multiple
                    v-model="reAprProductGroupId"
                  ></select2> -->
                  <treeselect
                    v-model="reAprProductGroupId"
                    :multiple="true"
                    :options="reAprProductGroupIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAprProductTypeId'"
                    :name="'reAprProductTypeId'"
                    :select2-options="reAprProductTypeIdOptions"
                    multiple
                    v-model="reAprProductTypeId"
                  ></select2> -->
                  <treeselect
                    v-model="reAprProductTypeId"
                    :multiple="true"
                    :options="reAprProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์สินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAprProductBrandId'"
                    :name="'reAprProductBrandId'"
                    :select2-options="reAprProductBrandIdOptions"
                    multiple
                    v-model="reAprProductBrandId"
                  ></select2> -->
                  <treeselect
                    v-model="reAprProductBrandId"
                    :multiple="true"
                    :options="reAprProductBrandIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อสินค้า:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reAprAssetProductCode'"
                    :name="'reAprAssetProductCode'"
                    :select2-options="reAprAssetProductCodeOptions"
                    multiple
                    v-model="reAprAssetProductCode"
                  ></select2> -->
                  <treeselect
                    v-model="reAprAssetProductCode"
                    :multiple="true"
                    :options="reAprAssetProductCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="ExportAverageBarcode($event)" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="AverageBarcodeTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="13">
                      ข้อมูล ณ วันที่ {{ reAprDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">รอบข้อมูล</th>
                    <th class="all text-center">รายการ</th>
                    <th class="all text-center">โรงงาน / คลังสินค้า</th>
                    <th class="all text-center">หมวดหมู่สินค้า</th>
                    <th class="all text-center">ประเภทสินค้า</th>
                    <th class="all text-center">ชื่อสินค้า</th>
                    <th class="all text-center">แบรนด์สินค้า</th>
                    <th class="all text-center">จำนวนรวมครั้งต่อปี</th>
                    <th class="all text-center">จำนวนบาร์โค้ด</th>
                    <th class="all text-center">รอบเฉลี่ยต่อปี</th>
                    <th class="all text-center">รอบสูงสุดต่อปี</th>
                    <th class="all text-center">รอบต่ำสุดต่อปี</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reAprDateReq: null,
      reAprIsInitial: true,
      reAprDateCycle: null,
      reAprPlantCode: [],
      reAprJobTypeCode: [],
      reAprProductGroupId: [],
      reAprProductTypeId: [],
      reAprProductBrandId: [],
      reAprAssetProductCode: [],

      reAprDateCycleOptions: {
        placeholder: "กรุณาเลือกรอบข้อมูล",
        allowClear: true,
        ajax: {
          url: "/Api/Jobs/DistinctJobDate/Options",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      reAprJobTypeCodeOptions: [],
      // reAprJobTypeCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะ",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=JOB_TYPE",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprPlantCodeOptions: [],
      // reAprPlantCodeOptions: {
      //   placeholder: "กรุณาเลือกโรงงาน / คลังสินค้า",
      //   multipla: true,
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Plant/Select2Plant",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprProductGroupIdOptions: [],
      // reAprProductGroupIdOptions: {
      //   placeholder: "กรุณาเลือกหมวดหมู่สินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductGroup/Select2ProductGroup",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprProductTypeIdOptions: [],
      // reAprProductTypeIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกประเภทสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/ProductType/Select2ProductType",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprProductBrandIdOptions: [],
      // reAprProductBrandIdOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกแบรนด์สินค้า",
      //   ajax: {
      //     url: "/Api/ProductBrand/Select2SearchBrandExistProduct",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reAprAssetProductCodeOptions: [],
      // reAprAssetProductCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสินค้า",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Product/Select2Product",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reAprDateCycle = null;
      self.reAprPlantCode = [];
      self.reAprJobTypeCode = [];
      self.reAprProductGroupId = [];
      self.reAprProductTypeId = [];
      self.reAprProductBrandId = [];
      self.reAprAssetProductCode = [];

      $("#reAprDateCycle")
        .empty()
        .trigger("change");

      $("#reAprPlantCode")
        .val("")
        .trigger("change");

      $("#reAprJobTypeCode")
        .val("")
        .trigger("change");

      $("#reAprProductGroupId")
        .val("")
        .trigger("change");

      $("#reAprProductTypeId")
        .val("")
        .trigger("change");

      $("#reAprProductBrandId")
        .val("")
        .trigger("change");

      $("#reAprAssetProductCode")
        .val("")
        .trigger("change");
    },
    formSubmit: function(e) {
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      e.preventDefault();
      var table = $("#AverageBarcodeTable").DataTable();
      table.draw();
    },
    LoadreAprJobTypeCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=JOB_TYPE", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAprJobTypeCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAprPlantCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Plant/Select2Plant", {
          all: true,
          page: 1,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAprPlantCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAprProductGroupIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductGroup/Select2ProductGroup", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAprProductGroupIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAprProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAprProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAprProductBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAprProductBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreAprAssetProductCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reAprAssetProductCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ExportAverageBarcode: function (e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }
      
      e.preventDefault();
      let self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportAverageBarcode",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reAprIsInitial,
          DateCycle: self.reAprDateCycle,
          PlantCode: self.reAprPlantCode,
          JobTypeCode: self.reAprJobTypeCode,
          ProductGroupId: self.reAprProductGroupId,
          ProductTypeId: self.reAprProductTypeId,
          AssetProductCode: self.reAprAssetProductCode,
          ProductBrandId: self.reAprProductBrandId,
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
  },
  async mounted() {
    let self = this;

    self.LoadreAprJobTypeCodeOptions();
    self.LoadreAprPlantCodeOptions();
    self.LoadreAprProductGroupIdOptions();
    self.LoadreAprProductTypeIdOptions();
    self.LoadreAprProductBrandIdOptions();
    self.LoadreAprAssetProductCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reAprDateReq = moment().format("DD/MM/YYYY h:mm a");

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#AverageBarcodeTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/AverageBarcode",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            let jsonSearch = {
              IsInitial: self.reAprIsInitial,
              DateCycle: self.reAprDateCycle,
              PlantCode: self.reAprPlantCode,
              JobTypeCode: self.reAprJobTypeCode,
              ProductGroupId: self.reAprProductGroupId,
              ProductTypeId: self.reAprProductTypeId,
              AssetProductCode: self.reAprAssetProductCode,
              ProductBrandId: self.reAprProductBrandId,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[1, "desc"]],
        columns: [
          { data: "dateCycle", className: "text-center" },
          { data: "jobTypeName", className: "text-center" },
          { data: "plantName", className: "text-center" },
          { data: "productGroupName", className: "text-center" },
          { data: "productTypeName", className: "text-center" },
          { data: "assetProductName", className: "text-center" },
          { data: "productBrandName", className: "text-center" },
          {
            data: "totalCycles",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "totalBarcodes",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null || data != "" || data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          { data: "averageCycles", className: "text-center" },
          { data: "maxCycle", className: "text-center" },
          { data: "minCycle", className: "text-center" },
        ],
        drawCallback: function(settings) {
          self.reAprIsInitial = false;
          self.reAprDateReq = moment().format("DD/MM/YYYY h:mm a");

          // var allPage = table.DataTable().page.info().pages;
          // var currentPage = table.DataTable().page.info().page +1;

          // self.isShowFooter = false;
          // self.TotalAmount = 0;

          // if(allPage == currentPage){
          //   self.isShowFooter = true;
          //   self.TotalAmount = settings.json.data[0].totalAmount;
          // }
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        reAprDateCycle: "required",
      },
      messages: {
        reAprDateCycle: "กรุณาเลือกรอบข้อมูล",
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/AverageBarcode.vue